import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const IngredientsSection = () => {
  const ingredients = [
  {
    name: 'Organic Vegetables',
    source: 'Certified organic farms in Punjab',
    image: "/assets/images/organic-vegetables-1766910267352.jpg",
    alt: 'Fresh organic vegetables including carrots, cauliflower and green chilies on wooden crate',
    icon: 'SparklesIcon'
  },
  {
    name: 'Traditional Spices',
    source: 'Sourced from Kerala spice gardens',
    image: "/assets/images/traditional-spices-1766910340754.jpg",
    alt: 'Colorful traditional Indian spices in wooden bowls including turmeric, red chili and mustard seeds',
    icon: 'FireIcon'
  },
  {
    name: 'Pure Mustard Oil',
    source: 'Cold-pressed from local mustard seeds',
    image: "/assets/images/pure-mustard-oil-1766910400154.jpg",
    alt: 'Golden mustard oil in traditional glass bottle with mustard seeds scattered around',
    icon: 'BeakerIcon'
  },
  {
    name: 'A2 Cow Milk',
    source: 'Indigenous cows from Gujarat',
    image: "/assets/images/A2-cow-milk-1766910463648.png",
    alt: 'Fresh A2 cow milk in traditional brass container with indigenous cow in background',
    icon: 'HeartIcon'
  }];


  const comparison = [
  {
    aspect: 'Preservatives',
    commercial: 'Sodium benzoate, potassium sorbate',
    ours: 'Natural fermentation only',
    icon: 'XCircleIcon'
  },
  {
    aspect: 'Oil Quality',
    commercial: 'Refined vegetable oil',
    ours: 'Cold-pressed mustard/sesame oil',
    icon: 'BeakerIcon'
  },
  {
    aspect: 'Ingredients',
    commercial: 'Artificial colors & flavors',
    ours: '100% natural ingredients',
    icon: 'SparklesIcon'
  },
  {
    aspect: 'Processing',
    commercial: 'Mass production methods',
    ours: 'Traditional hand-made process',
    icon: 'HandRaisedIcon'
  }];


  return (
    <section className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-6">
        <div className="mb-12 text-center">
          <h2 className="font-heading mb-4 text-3xl font-bold text-foreground lg:text-4xl">
            <span className="text-primary">Ingredient Transparency</span>
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Know exactly where every ingredient comes from and how it's processed
          </p>
        </div>

        <div className="mb-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {ingredients.map((ingredient, index) =>
          <div
            key={index}
            className="group overflow-hidden rounded-2xl bg-card shadow-cta transition-all duration-250 ease-out hover:shadow-lg">

              <div className="relative h-48 overflow-hidden bg-muted">
                <AppImage
                src={ingredient.image}
                alt={ingredient.alt}
                className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110" />

                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <Icon
                  name={ingredient.icon as any}
                  size={32}
                  className="text-primary" />

                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading mb-1 text-lg font-bold text-foreground">
                  {ingredient.name}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {ingredient.source}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="rounded-2xl bg-muted p-8 lg:p-12">
          <h3 className="font-heading mb-8 text-center text-2xl font-bold text-foreground lg:text-3xl">
            Commercial vs. <span className="text-primary">Granny'z Farm Fresh</span>
          </h3>

          <div className="space-y-4">
            {comparison.map((item, index) =>
            <div
              key={index}
              className="grid gap-4 rounded-xl bg-background p-6 shadow-cta lg:grid-cols-3">

                <div className="flex items-center gap-3">
                  <Icon
                  name={item.icon as any}
                  size={24}
                  className="flex-shrink-0 text-primary" />

                  <span className="font-bold text-foreground">
                    {item.aspect}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon
                  name="XMarkIcon"
                  size={20}
                  className="flex-shrink-0 text-error" />

                  <span className="text-sm text-muted-foreground">
                    {item.commercial}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <Icon
                  name="CheckIcon"
                  size={20}
                  className="flex-shrink-0 text-success" />

                  <span className="text-sm font-medium text-foreground">
                    {item.ours}
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="mt-8 rounded-xl bg-success/10 p-6 text-center">
            <Icon
              name="ShieldCheckIcon"
              size={48}
              className="mx-auto mb-4 text-success" />

            <h4 className="font-heading mb-2 text-xl font-bold text-foreground">
              FSSAI Certified & Organic Approved
            </h4>
            <p className="text-muted-foreground">
              All our products meet the highest food safety standards and are
              certified organic by India Organic
            </p>
          </div>
        </div>
      </div>
    </section>);

};

export default IngredientsSection;